import { parseMissionDate } from '../../../../../../utils/missionDates';

/**
 * Format a timestamp as relative time (mission cards, metadata).
 * Uses parseMissionDate so the instant matches DatePicker / mission date rules.
 */
export function formatRelativeTime(dateStr) {
  if (!dateStr) return null;

  const date = parseMissionDate(dateStr);
  if (!date) return null;

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  // Future (or clock skew): negative diff used to make minutes negative, which wrongly matched `minutes < 1` → "Just now"
  if (diffMs < 0) {
    const ahead = -diffMs;
    const minutesAhead = Math.floor(ahead / (1000 * 60));
    const hoursAhead = Math.floor(ahead / (1000 * 60 * 60));
    const daysAhead = Math.floor(ahead / (1000 * 60 * 60 * 24));
    if (minutesAhead < 1) return 'in a moment';
    if (minutesAhead < 60) return `in ${minutesAhead}m`;
    if (hoursAhead < 24) return `in ${hoursAhead}h`;
    if (daysAhead < 7) return `in ${daysAhead}d`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  const minutes = Math.floor(diffMs / (1000 * 60));
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);
  if (days < 7) return `${days}d ago`;
  if (weeks < 4) return `${weeks}w ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
